<style lang='less' scoped>
//滚动条样式
::-webkit-scrollbar {width: 0.06rem;height: 0.05rem;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-track-piece {border: 1px solid gray;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-thumb:vertical {height: 0.05rem;background-color: gray; border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-thumb:horizontal {width: 7px;background-color: gray;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
.cx-fi{margin-right:0.02rem;font-size: 0.12rem;}
.container{position:absolute;width: 5rem;height: 2.5rem;background:rgba(1,34,67, 0.9);border-radius: 0.15rem;z-index: 13;// 比弹框优先级低
  .head{display: flex;justify-content: space-between;width: 100%;height: 16%;align-items: center;color: #fff;font-size: 0.18rem;background-color: #20cbc3;
background-image: linear-gradient(198deg, #20cbc3 0%, #2189da 52%, #20cbc3 100%);
overflow: hidden;
border-top-left-radius: 0.15rem;
border-top-right-radius: 0.15rem;
    .title{display: flex;flex-direction: column;justify-content: center;padding-right: 0.52rem;height: 100%;text-indent: 1em;background: url('./dialog-left-bg.png');background-size: 100% 100%;}
    .el-icon{margin-right: 0.1rem;font-style: normal;cursor: pointer;}}}
  .body{padding: 0.1rem 0.2rem;overflow: auto;}
  .footer{display: flex;justify-content: space-around;padding: 0.05rem 0.8rem;height: 13%;font-size: 0.14rem;color: white;align-items: center;border-top: 0.01rem dashed rgba(0,227,202);
    div{cursor: pointer;}
    img{vertical-align: middle;}}
  .bottom-arrow{position: absolute;left: 50%;bottom: -20px;width: 0;height: 0;border-left: 8px solid transparent;border-right: 8px solid transparent;border-top: 20px solid #fff;transform: translateX(-50%);}
:deep(.el-form){display: flex;flex-wrap: wrap;justify-content: space-between;}
:deep(.el-form--inline .el-form-item){margin-right: 0;}
:deep(.el-form-item){margin-bottom: 0;width: 48%;margin-top: 0.03rem;}
:deep(.el-form-item__label){height: 0.32rem;line-height: 0.32rem;font-weight: bold;}//max-width: 1.5rem;
::v-deep .el-form-item>.el-form-item__label::before{
  content: '';
  width: 0.05rem;height: 0.16rem;background: rgba(0,227,202);margin-top: 0.08rem;margin-right: 0.04rem;
}
::v-deep .el-form-item>.el-form-item__label::after{
  content: ':';
  color: white;
  margin-left: 0.01rem;
}
:deep(.el-form-item__label){
  color: white;
}
:deep(.el-form-item__content){line-height: 0.32rem;color: rgba(0,227,202);align-items: flex-start;}
.btnclass:hover{text-decoration: underline;color: rgba(0,227,202);}
</style>

<template>
<div class="container">
    <div class="head">
      <div class="title">{{title}}</div>
      <el-icon :size="16" color="white" @click="closeClick">X</el-icon>
    </div>
    <div class="body" :style="[btnList.length ? 'height: calc(2.5rem - 18% - 0.23rem - 0.4rem);' : 'height: 1.87rem;']">
      <el-form :inline="true" label-position="left">
        <el-form-item v-for="item in formList" :key="item.colname" :label="item.namec">
          {{ item.value }}
        </el-form-item>
      </el-form>
    </div>
    <div class="footer" v-if="btnList.length">
      <div v-for="(btn, index) in btnList" @click="btn.click" :key="index" class="btnclass">
        <span :class="btn.iconClass"  :style="{color: btn.color}"></span>{{ btn.name }}
      </div>
    </div>
    <!-- <div class="bottom-arrow"></div> -->
</div>
</template>

<script>
/**
 * 组件名称: 气泡弹窗
 * 研发时间: 2022.12.09
 * 研发人员: 张浩
 * 功能说明:
 *
 * 调用说明:
 * @prop  {String}        tilte                  汽包框名字
 * @prop  {Array}         formList               表单列表数据（格式：[{ value: '', namec: '孔编码:', colname: 'holecode' }]）
 * @prop  {Array}         btnList                表单列表数据（格式：[{ name: '详细信息', iconClass: 'cx-fi ic-service', color: '#467cbe', click: this.lookDetail }]）
 *
 * 事件说明:
 * @event 事件名             参数解构                        事件和参数说明
 *
 */

/**
 * 维护历史:
 * 修改时间  人员      说明
 */
export default {
  data()
  {
    return {
    }
  },
  props: {
    title: { type: String, default: '' },
    formList: { type: Array, default: () => [] },
    btnList: { type: Array, default: () => [] }
  },
  created()
  {
    console.log(this.formList)
  },
  methods: {
   
    // 关闭属性查看弹窗
    closeClick()
    {
      if (this.closeEvent)
      {
        delete window.popups
        this.closeEvent()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/popup/index.vue